export const ApplyGiftNoteStyles = () => {
  const cssText = `
    p,
    button,
    label,
    input,
    textarea,
    {
      font-family: NeuzitGro, serif !important;
      font-weight: 400 !important;
      font-size: 18px !important;
      line-height: 24px !important;
    }

    #giftnote-modal-title {
      font-size: 31px !important;
      line-height: 38px !important;
      font-weight: 500 !important;
    }

    label, input {
      font-size: 16px !important;
    }

    div, button, li, ul {
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    .ring-inset {
      border: 1px solid #333333 !important;
    }

    #save-button {
      background-color: #fff !important;
      cursor: pointer;
      color: #333333 !important;
      border: 1px solid #333 !important;
      font-size: 16px !important;
      padding: 10px 35px !important;
      letter-spacing: normal !important;
      line-height: 16px !important;
    }

    #save-button:hover {
      color: #666 !important;
    }


    #scheduled-tab {
      font-size: 16px !important;
      padding: 10px 35px !important;
      border-left: none !important;
      line-height: 16px !important;
      letter-spacing: normal !important;

    }

    button.active {
      background-color: #333 !important;
      color: #fff !important;
      font-size: 16px !important;
      padding: 10px 35px !important;
      line-height: 16px !important;
      letter-spacing: normal !important;
    }

    #instant-panel {
      color: #333 !important;
    }

    #instant-tab{
      font-size: 16px !important;
      line-height: 16px !important;
      letter-spacing: normal !important;

      }

    #method {
      border: 1px solid #333333 !important;
    }
    #methods{
        padding: 10px 35px !important;
        border-color: #333333 !important;
        border-left: none;
        border-right: none;
        background: unset;
        border-top: none;
        border-bottom: none;
        padding-left: 0px !important;
        padding-right: 0px !important;
        color: #333333 !important;
        font-size: 16px !important;
    }

    #form {
      border-top: 1px solid #333333 !important;
    }

    #content form,
    #content form *:focus,
    #content form *:focus-within:not(#methods) {
      --tw-ring-color: #333333 !important;
      border-color: #333333 !important;
    }

    #close- {
      cursor: pointer;
    }

    #close- svg {
      color: #333333 !important;
    }

    #remove- {
      color: #333333 !important;
      cursor: pointer;
    }

    #remove-:hover {
      background-color: #333333 !important;
      color: white !important;
    }

    #content .error,
    #content .medium-error,
    #content .required,
    #content .invalid {
      --tw-ring-color: #d7696d !important;
      border-color: #d7696d !important;
    }

    .text-red-500 {
      color: #d7696d !important;
    }

    #powered {
      opacity: 0 !important;
    }
  `;

  // Placeholder for button CSS text
  const addButtonCssText = `
    /* Add your giftnote-button styles here */
    #button{
    font-family: NeuzitGro, serif !important;
      font-weight: 400 !important;
      font-size: 16px !important;
      line-height: 16px !important;
    border-radius: 0 !important;
    padding: 10px 35px !important;
    letter-spacing: normal !important;
    height:auto !important;
    }
    #button:hover{
    color: #666 !important;}
  `;

  setTimeout(() => {
    const elems = document.querySelectorAll("giftnote-core");
    const buttonElements = document.querySelectorAll("giftnote-voucher-button");
    buttonElements.forEach((buttonElement) => {
      const buttonStyle = document.createElement("style");
      buttonStyle.textContent = addButtonCssText;
      buttonElement?.shadowRoot?.appendChild(buttonStyle);
    });
    elems.forEach((elem) => {
      const newStyle = document.createElement("style");
      newStyle.textContent = cssText;
      elem?.shadowRoot?.appendChild(newStyle);
    });
  }, 1500);
};
